import { Component, OnInit } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../models/bary-modal-event';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaryComponentHelper } from '../../../../shared/util/bary-component-helper';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { LastEstimate } from '../../../../../models/estimate-result-bundle.model';

@Component({
  selector: 'jhi-bary-modal-transporter-cancel-quotation-confirmation',
  styleUrls: ['./bary-modal-transporter-cancel-quotation-confirmation.component.scss'],
  templateUrl: './bary-modal-transporter-cancel-quotation-confirmation.component.html',
})
export class BaryModalTransporterCancelQuotationConfirmationComponent implements OnInit {
  quotationForm!: FormGroup;
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  loaded = false;
  lastEstimate?: LastEstimate;

  constructor(private modalRef: MDBModalRef) {}

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  public ngOnInit(): void {
    this.quotationForm = new FormGroup({
      quotationRejectionMessage: new FormControl('', [Validators.required]),
    });

    this.loaded = true;
  }

  public getControl(controlName: string): FormControl {
    return this.quotationForm.get(controlName) as FormControl;
  }

  public submit(): void {
    if (this.quotationForm.invalid) {
      return;
    }
    this.action.next(new BaryModalEvent({ submit: true, value: this.quotationForm.value }));
    this.modalRef.hide();
  }
}
